import React from 'react';
import { Container, Row, Col, } from 'react-bootstrap';
import { FaPhoneVolume } from "react-icons/fa6";
import { MdLocationOn, MdOutlineEmail } from "react-icons/md";
import Imgxing from '../../assets/xingImg.png'
import Imglinkidin from '../../assets/Linkdin.png'
import Imgyoutube from '../../assets/youtube.png'
import Imgkaggle from '../../assets/kaggleImg.png'
import Imgfacebook from '../../assets/Facebook.png'
import ImgInstagram from '../../assets/insta logo.jpg'
import { Link } from 'react-router-dom';
import './HfFooter.css'
import imgCaGov from '../../assets/ca-gov.png';
import accessibility from '../../assets/policy/Accessibility-Policy-HFC.pdf';
import { useTranslation } from 'react-i18next';
import { FaLandmark } from 'react-icons/fa';


const HfFooter = () => {
  const { t } = useTranslation();
  return (
    <footer className='hfFooter-wrapper' id='contact-us-section'>
      <Container className='hfFooter-container'>
        <Row className="justify-content-center " style={{ marginLeft: 'auto' }}>
          <Col sm={12} lg={4} >
            <div className='footer-column-div'>
              <b>{t('How to reach us')}</b>
              <ul>
                <li><a href="https://maps.app.goo.gl/aNU72gKScAuosA11A" target="_blank" rel="noopener noreferrer" className="footer-link"><FaLandmark /> {t("HANSA-FLEX Hidraulika d.o.o.,")}<br /> {t("Lole Ribara 120,")}<br /> {t("11250 Beograd - Železnik,")}<br /> {t("Serbia")}</a></li>
                <li><a href="tel:+381 11 2577 662" className="footer-link"><FaPhoneVolume /> +381 11 2577 662</a></li>
                <li><a href="tel:+381 11 2589 663" className="footer-link"><FaPhoneVolume /> +381 11 2589 663</a></li>
                <li><a href="tel:+381 11 2571 062" className="footer-link"><FaPhoneVolume /> +381 11 2571 062</a></li>
                <li><a href="mailto:info.srb@hansa-flex.com" className="footer-link"><MdOutlineEmail /> info.srb@hansa-flex.com</a></li>
                {/* <li><a href="https://www.hansa-flex.de/niederlassungssuche/" target='_blank' className="footer-link"><MdLocationOn />{t("Branch finder")}</a></li> */}
              </ul>
              <br />
            </div>
          </Col>

          {/* <Col sm={12} lg={3} >
            <div className='footer-column-div'>
              <b>{t('Branch Hotline - 24 hours')}</b>
              <ul>
                <li><a href="tel:0800 042 0112" className="footer-link"><FaPhoneVolume /> 0800 042 0112</a></li>
              </ul>
              <b>{t('MHS - Mobile Hydraulic Service - 24 hours')}</b>
              <ul>
                <li><a href="tel:0800 042 0112" className="footer-link"><FaPhoneVolume /> 0800 042 0112</a></li>
              </ul>
              <br />
            </div>
          </Col> */}

          <Col sm={12} lg={4}>
            <div className='footer-column-div'>
              <b>{t("About HANSA-FLEX")}</b>
              <ul>
                <li><Link to="/who-we-are" className="footer-link">{t("Company")}</Link></li>
                <li><Link to="/certificates" className="footer-link">{t("Certificates")}</Link></li>
                {/* <li><Link to="/hf-group-mission-statement" className="footer-link">Guidelines</Link></li> */}
                {/* <li><Link to="/careers" className="footer-link">Careers</Link></li> */}
              </ul>
              <br />
            </div>
          </Col>


          <Col sm={12} lg={4}>
            <div className='footer-column-div'>
              <b>{t("Services")}</b>
              <ul>
                <li><Link to="/hydraulic-cyclinder-repair" className="footer-link">{t("Cylinder repair")}</Link></li>
                <li><Link to="/mobile-rapid-hydraulic-service" className="footer-link">{t("FLEXXPRESS mobile service")}</Link></li>
                <li><Link to="/x-code-manager" className="footer-link">{t("X-code manager")}</Link></li>
              </ul>
            </div>
          </Col>

          {/* <Col sm={12} lg={3}>
            <div className='footer-column-div'>
              <b>{t('Popular Categories')}</b>
              <ul>
                <li><Link to="/hydraulic-hoses" className="footer-link">{t("Hydraulic Hoses")}</Link></li>
                <li><a href="https://my.hansa-flex.rs/sr_RS/login" target="_blank" rel="noopener noreferrer" className="footer-link">{t("My.HANSA-FLEX")}</a></li>
              </ul>
              <br />
            </div>
          </Col>

          <Col sm={12} lg={3}>
            <div className='footer-column-div'>

            </div>
          </Col> */}

        </Row>

        {/* <Row>
          <Col className="d-flex justify-content-center align-items-center">
            <b>{t('Follow us')}</b>
          </Col>
        </Row> */}


        {/* <Row className="custom-3row ">
          <Col><div className="circle-col"><a href="https://www.linkedin.com/company/hansa-flex-ag/?originalSubdomain=de" target="_blank" rel="noopener noreferrer"><div><img src={Imglinkidin} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.youtube.com/channel/UCxEVYG0w2OgkYzkLDiWIoOA" target="_blank" rel="noopener noreferrer"><div><img src={Imgyoutube} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.instagram.com/hansaflex_ag/" target="_blank" rel="noopener noreferrer"><div><img src={ImgInstagram} alt="" /></div></a></div></Col>
          <Col><div className="circle-col"><a href="https://www.facebook.com/hansaflexag" target="_blank" rel="noopener noreferrer"><div><img src={Imgfacebook} alt="" /></div></a></div></Col>
        </Row> */}

        <Row className="line-row">
          <Col className="line-col"></Col>
        </Row>

        <div className='HfFooter-link-div'>
          <a className="hf-footer-link" href="">{t("© Copyright, All rights reserved")}</a>
          {/* <span>  |  </span>
          <Link to="/hansa-flex-india-privacy-policy" className="footer-link">{t("Privacy Policy")}</Link> */}


          {/*<a className="hf-footer-link" href="">GT&C</a><span>  |  </span>
          <a className="hf-footer-link" href="">Purchasing and logistics</a><span>  |  </span>
        <a className="hf-footer-link" href="">Data protection</a>*/}

        </div>



      </Container>
    </footer >

  );
};

export default HfFooter;
